<template>
    <div class="py-3 categoriescir">
        <div class='container px-0' >
            <h3 class="py-4">CATEGORIES</h3>
            <b-container>
			
			  <div>
				<VueSlickCarousel v-bind="settings">
				  <b-col class="d-flex align-items-center flex-column"  v-for="(data,index) in bannerItems" :key="index">
				  <b-link :href="data.url" >
				  <b-img-lazy v-bind="mainProps" class=" circle border border-purple rounded-circle" :src="$root.MEDIAPATH+'banners/category/'+data.img" fluid ></b-img-lazy> 
				  <!--<b-img-lazy   v-bind="mainProps" :src="$root.MEDIAAPI+'tool/get_image?size=540x450&src='+$root.MEDIAPATH+'banners/kiwikkrrush/'+data" fluid  alt="Responsive image" ></b-img-lazy>-->
				  
				  <h3 class="text-center">{{data.title}}</h3>  
				  
				  </b-link>
				  </b-col>
				</VueSlickCarousel>
			  </div>


           
            </b-container>
        </div> 
    </div>
</template>
<script>

import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'HeroCarousel',
    components: {VueSlickCarousel},
    data() {
        return {
            mainProps: { class: 'm1', center: true,blankColor: '#fff',width:284,height:284},
            settings: {
                "arrows": true,
                "dotsClass": "slick-dots custom-dot-class",
                "edgeFriction": 0.35,
                "infinite": true,
                "autoplay": true,
                "speed": 500,
                "cssEase": "linear",
                "slidesToShow": 4,
                "slidesToScroll": 1,
                "responsive": [
					{
					  "breakpoint": 1024,
					  "settings": {
						"slidesToShow": 3,
						"slidesToScroll": 3,
						"infinite": true,
						"dots": true
					  }
					},
					{
					  "breakpoint": 600,
					  "settings": {
						"slidesToShow": 2,
						"slidesToScroll": 2,
						"initialSlide": 2
					  }
					},
					{
					  "breakpoint": 480,
					  "settings": {
						"slidesToShow": 1,
						"slidesToScroll": 1
					  }
					}
				  ]
            },
			bannerItems:[		 
			 //{img:"Fashion.png",title:"Fashion",url:"/fashion"},
			 {img:"Saree.png",title:"Saree",url:"/sarees"},
			 {img:"Cosmetics.png",title:"Cosmetics",url:"/cosmetics"},
			 {img:"Skin-Care.png",title:"Skin Care",url:"/skin-care"},
			 {img:"Hair-Care.png",title:"Hair Care",url:"/hair-care"},
			 {img:"Mens-Fashion.png",title:"Men's Fashion",url:"/men"},
			 {img:"Womens-Fashion.png",title:"Women's Fashion",url:"/women"},
			 {img:"lehenga.png",title:"Lehenga",url:"/lehenga-choli"},
			 {img:"Kurti.png",title:"Kurti",url:"/kurtis-tops"},
			 {img:"Makeup.png",title:"Makeup",url:"/makeup"},
			 {img:"Handbags&Clutches.png",title:"Handbags & Clutches",url:"/handbags-clutches"},
			 {img:"jewellery.png",title:"Jewellery ",url:"/women-jewellery"},
			 {img:"Womens-Shoes.png",title:"Women's Shoes",url:"/women-shoes"},
			 {img:"Mens-Shoes.png",title:"Men's Shoes",url:"/men-footwear"},
			 {img:"Accessories.png",title:"Accessories",url:"/women-accessories"}
			 ],
			
        }
    },
}
</script>
<style lang="scss">
.categoriescir{
	/*.slick-next:before {
		content: '→';
	}*/
	
	.border-purple {
        border: 2px solid purple  !important;
    }
	.slick{
		&-prev {
		  /*left: 3% !important;*/
		  top: 45% !important;
		  z-index: 0;
			width: 25px;
			height: 25px;
			background-color: #FFF;
			box-shadow: #bbb 0px 0px 6px;
			border-radius: 100px;
			
		  &:before{ 					
				content: 'prev'; 
				font-family: swiper-icons;
				color: #683581;
				font-size: 15px;
				font-weight: 700;
			}
			
		  
		}
		&-next {
		 /* right: 3% !important;*/
			top: 45% !important;
			
		  	width: 25px;
			height: 25px;
			background-color: #FFF;
			box-shadow: #bbb 0px 0px 6px;
			border-radius: 100px;

			&:before{ 	
					content: 'next'; 
					font-family: swiper-icons;
					color: #683581;
					font-size: 15px;
					font-weight: 700;
				}
			
		} 
	
	}
    

}
 
</style>